<template>
  <button
    class="p-theme-button"
    :class="{ outlined: outlined || text, text, block, fullWidth }"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </button>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class ThemeButton extends Vue {
  @Prop(Boolean) outlined!: boolean;
  @Prop(Boolean) block!: boolean;
  @Prop(Boolean) fullWidth!: boolean;
  @Prop(Boolean) text!: boolean;
}
</script>

<style lang="scss">
@import '@/assets/scss/base.scss';
.p-theme-button {
  color: $filled-button-text-color;
  background-color: $filled-button-background;
  border: none;
  cursor: pointer;

  &.block {
    display: block;
  }
  &.fullWidth {
    width: 100%;
  }

  &:active {
    border: none;
  }

  &:disabled {
    color: $filled-button-text-color--disabled;
    background-color: $filled-button-background--disabled;
    cursor: not-allowed;
  }

  &.outlined {
    background: $outline-button-background;
    color: $outline-button-text-color;
    border: 1px solid $outline-button-outline-color;

    &:disabled {
      color: $outline-button-text-color--disabled;
      background-color: $outline-button-background--disabled;
    }

    &:active {
      border: 1px solid $outline-button-outline-color;
    }

    &.text {
      border: none;
    }
  }
}
</style>
